import _ from 'lodash';
import template from './userLog.html';

export default {
  name: 'userLogComponent',
  template,
  controller: UserLogController,
  controllerAs: 'UserLogCtrl'
};

/* @ngInject */
function UserLogController($scope, $stateParams, growl, NgTableParams, UserLogService) {
  const vm = this;

  //
  // set start date to one year ago at the start of the day
  // set end day to today at the end of the day
  //
  const now = new Date();
  const end = now.setHours(23, 59, 59, 999); // eslint-disable-line no-magic-numbers
  const start = new Date(now.setMonth(now.getMonth() - 1)).setHours(0, 0, 0, 0);

  // Public Methods //
  vm.flagThisEntry = flagThisEntry;
  vm.saveEntryNotes = saveEntryNotes;
  vm.getUserLog = getUserLog;

  // Public Variables //
  vm.selectedOptionsForUserLog = {
    date: {
      start: new Date(start),
      end: new Date(end)
    }
  };

  vm.startDate = {
    opened: false,
    open($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.startDate.opened = true;
      vm.endDate.opened = false;
    }
  };

  vm.endDate = {
    opened: false,
    open($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.endDate.opened = true;
      vm.startDate.opened = false;
    }
  };

  vm.tableParams = new NgTableParams({
    page: 1,
    count: 10,
    sorting: {
      createdAt: 'desc'
    },
    filter: {}
  }, {
    total: 0,
    getData($table) {
      let sortString = '';
      if ($table.sorting()) {
        const sorted = $table.sorting();
        const firstSorted = Object.keys(sorted)[0];
        sortString = `${firstSorted}|${sorted[firstSorted]}`;
      }
      let filterString = '';
      if ($table.hasFilter()) {
        let count = -1;
        _.forEach($table.filter(), (val, key) => {
          count += 1;
          if (val !== '') {
            if (count > 0 && filterString !== '') {
              filterString += '|';
            }
            filterString += `${key}__${val}`;
          }
        });
      }

      // if no dashboard is selected, send all of the dashboard IDs
      const { start: optStart, end: optEnd } = vm.selectedOptionsForUserLog.date;
      const { page, count } = $table._params;
      return UserLogService
        .getUserLog($stateParams.id, optStart.valueOf(), optEnd.valueOf(), page, count, sortString, filterString)
        .then((success) => {
          $table.total(success.data.count);
          return success.data.entries;
        })
        .catch((error) => {
          $table.log(error);
        });
    }
  });

  $scope.$watch('selectedOptionsforUserLog.date.start', (newVal) => {
    if (vm.selectedOptionsForUserLog.date.end && (newVal > vm.selectedOptionsForUserLog.date.end)) {
      vm.selectedOptionsForUserLog.date.end = '';
    }
  });

  function flagThisEntry(entry) {
    let growlMessage = growl.info('Flagging entry...', {
      disableCloseButton: true
    });
    entry.flagged = !entry.flagged;
    UserLogService.updateEntry(entry.id, {
      flagged: entry.flagged
    })
      .then(() => {
        vm.tableParams.reload();
        growlMessage.destroy();
        growlMessage = growl.success('Entry flagged successfully');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error Flagging Entry:'
        });
      });
  }

  function saveEntryNotes({ id, notes }) {
    let growlMessage = growl.info('Saving notes...', {
      disableCloseButton: true
    });
    UserLogService.updateEntry(id, {
      notes
    })
      .then(() => {
        vm.tableParams.reload();
        growlMessage.destroy();
        growlMessage = growl.success('Notes saved successfully');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error Saving Notes:'
        });
      });
  }

  function getUserLog() {
    vm.tableParams.reload();
  }
}
